import { Component } from '@angular/core';

import { DateProviders } from '../../../../common/component/datetime-picker';
import { TakeUntilDestroy } from '../../../../common/take-until-destroy.decorator';
import { currentBuilderState } from '../../builder.state';
import { BuilderState } from '../../model/builder-state.model';
import { SelectionService } from '../../service/selection.service';

@Component({
    selector: 'cmps-report-builder-raw-date',
    templateUrl: './raw-date.component.html',
    providers: [DateProviders],
})
@TakeUntilDestroy()
export class RawDateComponent {
    /** @private */
    _state: BuilderState;

    constructor(private readonly _selectionService: SelectionService) {
        this._state = currentBuilderState();
    }

    /** @private */
    _onChange(wasStart: boolean): void {
        this._selectionService.onRawDateChange(wasStart);
    }
}
